import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FichaMedicaService } from 'src/app/services/ficha-medica.service';
import { EncriptacionService } from 'src/app/services/encriptacion.service';
import { CompleterService, CompleterData } from 'ng2-completer';

@Component({
  selector: 'app-historial-consultas-medico',
  templateUrl: './historial-consultas-medico.component.html',
  styleUrls: ['./../../../assets/css/styles.css', './historial-consultas-medico.component.css']
})
export class HistorialConsultasMedicoComponent implements OnInit {
  consulta: any = [];
  consultas: any = [];
  consultas_list: any;
  consultas_aux: any;
  public appointments: any[] = [];
  public auxAppts: any[] = [];
  public auxAppts_fin: any[] = [];
  solo_fecha: boolean = true;
  f_desde: any = '';
  f_hasta: any = '';
  anio: any;
  botones = null;
  ficha = null;
  accion = 0;
  modificar = false;
  usuario: any;
  showOptionFecha: boolean = true;
  completerData: CompleterData;
  strPacienteFilter: any = '';
  strPacienteFilter_fin: any = '';
  nombres_pacientes: Array<any> = [];

  constructor(private _fichaMedicaServices: FichaMedicaService, private completerService: CompleterService, private router: Router) {}

  ngOnInit(): void {
    this.usuario = new EncriptacionService().getUserInfo();
    this.verConsultas();
  }

  verConsultas() {
    const data = {
      doc_id: this.usuario.typ_name == 'PACIENTE' ? null : this.usuario._id,
      paciente: this.usuario.typ_name == 'PACIENTE' ? this.usuario.rut : null,
      date: null
    };

    this._fichaMedicaServices.getListarConsultasPasadas(data).then((results: any) => {
      if (!results?.consultas?.length) return;

      const consultas = results.consultas;

      for (let i = 0; i < consultas.length; i++) {
        const appt = consultas[i];
        const hour = appt.hora.substr(0, 2);
        const minute = appt.hora.substr(3, 2);
        const apptDate = new Date(appt.fecha_consulta.substr(0, 10).replaceAll('-', '/'));

        apptDate.setHours(Number(hour));
        apptDate.setMinutes(Number(minute));

        const now = new Date();
        this.anio = apptDate.getFullYear();

        const formatedApptDate = this.formatApptDate(apptDate, now);

        if (formatedApptDate.length > 0) {
          const confirmFlag: boolean = false;

          const apptData: any = {
            date: formatedApptDate,
            doctorName: appt.nombre_doctor.split(' ', 1)[0],
            doctorLastName: appt.apellido_paterno_doctor,
            spec: appt.spe_name,
            subSpec: appt.sub_spe_name,
            img: appt.img ? appt.img : '',
            confirmFlag,
            apptDate: new Date(appt.fecha_consulta.substr(0, 10).replaceAll('-', '/')),
            anio: apptDate.getFullYear(),
            confirmedFlag: appt.tel_doc_app_boo_sta_id === 30,
            id_consulta: appt.id_consulta,
            zoo_mee_room_id: appt.zoo_mee_room_id,
            med_con_id: appt.med_con_id,
            nombre_paciente: appt.nombre_paciente,
            apellido_paterno_paciente: appt.apellido_paterno_paciente,
            apellido_materno_paciente: appt.apellido_materno_paciente,
            email_doctor: appt.email_doctor,
            use_id: appt.use_id,
            consulta: appt,
            nombre_completo: `${appt.nombre_paciente} ${appt.apellido_paterno_paciente} ${appt.apellido_materno_paciente}`,
            sta_name: appt.sta_name,
            tel_doc_app_boo_is_ondemand: appt.tel_doc_app_boo_is_ondemand,
            motivo_cancelacion_videollamada: appt.motivo_cancelacion_videollamada ? appt.motivo_cancelacion_videollamada : '-'
          };

apptData.consulta.fecha_consulta = apptData.consulta.fecha_consulta.substr(0, 10).replace(/-/g, '/');
          this.appointments.push(apptData);
          this.auxAppts.push(apptData);

          const ind = this.nombres_pacientes.findIndex(pacie => pacie.nombre_completo == apptData.nombre_completo);
          if (ind < 0) this.nombres_pacientes.push({ nombre_completo: apptData.nombre_completo });
        }
      }

      this.completerData = this.completerService.local(this.nombres_pacientes, 'nombre_completo', 'nombre_completo');

      // Al cargar inicialmente se muestran todas las consultas
      this.auxAppts_fin = [...this.auxAppts];
    }).catch(e => console.log(e));
  }

  seleccionarFiltroFecha() {
    this.showOptionFecha = true;
    this.solo_fecha = true;
    this.strPacienteFilter = '';
    this.strPacienteFilter_fin = '';
    this.auxAppts_fin = [...this.auxAppts];
  }

  seleccionarFiltroNombre() {
    this.showOptionFecha = false;
    this.solo_fecha = false;
    this.strPacienteFilter = '';
    this.strPacienteFilter_fin = '';
  }

  changeFechas() {
  this.solo_fecha = true;

  if (!this.strPacienteFilter || !this.strPacienteFilter_fin) {
    this.auxAppts_fin = [...this.auxAppts];
    return;
  }

  const fechaDesde = this.normalizarFecha(this.strPacienteFilter);
  const fechaHasta = this.normalizarFecha(this.strPacienteFilter_fin);

  if (fechaDesde > fechaHasta) {
    this.auxAppts_fin = [];
    return;
  }

  this.auxAppts_fin = this.auxAppts.filter(appt => {
    const fechaConsulta = this.normalizarFecha(appt.consulta.fecha_consulta);
    return fechaConsulta >= fechaDesde && fechaConsulta <= fechaHasta;
  });
}

normalizarFecha(fecha: string): string {
  if (!fecha) return '';
  return fecha.substring(0, 10).replace(/[-/]/g, '');
}

  changeNamePaciente(event: any) {
    this.solo_fecha = false;
    this.strPacienteFilter_fin = '';
  }

  obtenerResta(hora: any) {
    const fecha = new Date(Date.now());
    const minutos = fecha.getHours() * 60 + fecha.getMinutes();
    const minutos_consulta = parseInt(hora.substr(0, 2)) * 60 + parseInt(hora.substr(3, 2));
    return minutos_consulta - minutos;
  }

  formatApptDate = (apptDate: Date, now: Date) => {
    const months = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];
    const month = months[apptDate.getMonth()];
    const returnDate: string[] = [`${apptDate.getDate()} de ${month}`, ''];
    return returnDate;
  }

  timeToX = (someDate: Date, now: Date) => someDate.getTime() - now.getTime();

  msToMin = (ms: number) => Math.floor(ms / 60000);

  isToday = (apptDate: Date, now: Date): boolean => {
    return apptDate.getFullYear() === now.getFullYear() && apptDate.getMonth() === now.getMonth() && apptDate.getDate() === now.getDate();
  }

  irdetallesPacientes(appt: any) {
    const url = 'historialConsultasDoc/paciente/' + appt.med_con_id;
    this.router.navigate([url]);
  }
}